$(document).ready(function(){
    let auto_click_term = $('#auto_click_service');
    if(auto_click_term.length){
        $('input[name="service"][data-service-id="' + auto_click_term.val() + '"]').trigger('click');
    }
});

$('.js-select-simple-service').change(function (){
    let employees = $('#use_employees').val();

    if(employees === 1){
        let selected_employee = $('.js-select-employee.selected');

        if(selected_employee.length){
            get_services_calendar(0,0, selected_employee.data('employee-id'));
        }else{
            get_services_employees();
        }
    }else{
        get_services_calendar();
    }
    add_get_param_to_url('service', $(this).val());
});

$(document).on('click', '.js-next-month, .js-prev-month', function (){

    let month = $(this).data('month');
    let year = $(this).data('year');

    let event_repeating_calendar_wrapper = $('.js-event-repeating-calendar-html');
    if(event_repeating_calendar_wrapper.length){

        let data_to_send = {
            action: 'get_event_repeating_calendar_html',
            event_id: $('#event_id').val(),
            month: month,
            year: year,
        };

        jQuery.post(BASE_URL+'/wp-admin/admin-ajax.php', data_to_send, function(response) {
            if (response) {
                event_repeating_calendar_wrapper.html(response);
                $('.js-available-terms-wrapper').html('');
                $('.js-event-repeating-term-services').html('');
            }
        });

    }else{
        let employee_id = $('.js-select-employee.selected').data('employee-id');
        get_services_calendar(month, year, employee_id);
    }
});

function get_services_employees(){
    let data_to_send = {
        action: 'get_simple_employees_html',
        zariadenie_id: $('#zariadenie_id').val(),
    };

    jQuery.post(BASE_URL+'/wp-admin/admin-ajax.php', data_to_send, function(response) {
        if(response){
            let services_employees_wrapper = $('#services-employees');
            services_employees_wrapper.html(response);
            scrollTo(services_employees_wrapper);

            let auto_click_employee = $('#auto_click_employee');
            if(auto_click_employee.length){
                $('.js-select-employee[data-employee-id="' + auto_click_employee.val() + '"]').trigger('click');
            }

        }
    })
}

/* generated by ChatGPT */
function calculate_time_till(time, length) {
    const [hours, minutes] = time.split(':').map(Number);
    const totalMinutes = (hours * 60 + minutes + length) % 1440; // 1440 = 24 hodín * 60 minút
    return `${String(Math.floor(totalMinutes / 60)).padStart(2, '0')}:${String(totalMinutes % 60).padStart(2, '0')}`;
}

$(document).on('click', '.js-select-employee', function(){
    $('.js-select-employee.selected').removeClass('selected');
    $(this).addClass('selected');
    let employee_id = $(this).data('employee-id');

    let urlParams = new URLSearchParams(window.location.search); //get all parameters
    let year = parseInt(urlParams.get('rok'));
    let month = parseInt(urlParams.get('mesiac'));
    let day = parseInt(urlParams.get('den'));

    if(!year) {
        year = 0;
    }
    if(!month){
        month = 0;
    }
    if(!day){
        day = 0;
    }

    get_services_calendar(month,year, employee_id, day);
    add_get_param_to_url('employee', employee_id);
})

function get_services_calendar(month = 0, year = 0, employee_id = 0, day_to_pick = 0){

    let calendar_wrapper = $('#services-calendar');
    $('table', calendar_wrapper).addClass('loading');
    $('#select-time').html('');

    let data_to_send = {
        action: 'get_simple_calendar_html',
        zariadenie_id: $('#zariadenie_id').val(),
        month: month,
        year: year,
        use_employees: $('#use_employees').val(),
        employee_id: employee_id
    };

    jQuery.post(BASE_URL+'/wp-admin/admin-ajax.php', data_to_send, function(response) {
        if(response){
            calendar_wrapper.html(response);

            let day_to_pick_el = $('.js-zariadenie-choose-day[data-day="' + day_to_pick + '"]');

            if(day_to_pick && day_to_pick_el.length){
                $('.js-zariadenie-choose-day[data-day="' + day_to_pick + '"]').trigger('click');
            }else if($('.js-zariadenie-choose-day').length){
                $('.js-zariadenie-choose-day').first().click();
            }else{
                let no_term_html = '<div class="alert alert-danger">'+ $('#select-time').data('no-terms') + '</div>';
                $('#select-time').html(no_term_html);

                add_get_param_to_url('mesiac', month);
            }
            scrollTo(calendar_wrapper);
        }
    })
}

$(document).on('click', '.js-refresh-day', function(){
    $('.js-zariadenie-choose-day.active').click();
})

$(document).on('click', '.js-zariadenie-choose-day', function (){
    $('.js-possible-times-wrapper').addClass('loading');
    $('.calendar td.active').removeClass('active');
    $(this).addClass('active');

    let day = $(this).data('day');
    let month = $(this).parents('table').data('month');
    let year = $(this).parents('table').data('year');
    let service_length = $('.js-select-simple-service:checked').data('service-length');

    let use_employees = $('#use_employees').val();
    let employee_id;

    if(use_employees){
        employee_id = $('.js-select-employee.selected').data('employee-id');
    }else{
        employee_id = false;
    }

    let data_to_send = {
        action: 'get_simple_calendar_time_slots_html',
        object_id: $('#zariadenie_id').val(),
        month: month,
        year: year,
        day: day,
        service_length: service_length,
        use_employees: use_employees,
        employee_id: employee_id
    };

    jQuery.post(BASE_URL+'/wp-admin/admin-ajax.php', data_to_send, function(response) {
        if(response){
            $('#select-time').html(response);
            add_get_param_to_url('den', day);
            add_get_param_to_url('mesiac', month);
            add_get_param_to_url('rok', year);
        }
    })
});

$(document).on('click', '.js-choose-time', function (){
    $('.js-choose-time.active').removeClass('active');
    $(this).addClass('active');
    let modal = $('.reservation-modal');
    modal.addClass('loading');
    modal_open(modal);

    let year = $('.js-calendar-table').data('year');
    let month = $('.js-calendar-table').data('month');
    let day = $('.js-zariadenie-choose-day.active').data('day');

    let selected_service = $('.js-select-simple-service:checked');
    let service_date = day+'.'+month+'.'+year;
    let service_time = $(this).data('time');
    let service_dayname = $(this).data('day-name');

    $('.js-modal-service-name').text(selected_service.next('.service-name').text());
    $('.js-modal-date').text(service_date);
    $('.js-modal-service-price').html(selected_service.data('service-price'));
    $('.js-modal-time').text(service_time);
    $('.js-modal-day-name').text(service_dayname);

    $('.js-modal-time-till').text( calculate_time_till(service_time, selected_service.data('service-length')) );

    let zamestnanci = $('#use_employees').val();

    if(zamestnanci == 1){
        let selected_employee = $('.js-select-employee.selected');
        $('.js-modal-service-employee').text(selected_employee.data('employee-name'))
    }

    $('.add_to_cart_button').removeAttr('disabled');
    modal.removeClass('loading');
});

$(document).on('submit', '.js-add-service-to-cart-form', function(e){
    e.preventDefault();

    let year = $('.js-calendar-table').data('year');
    let month = $('.js-calendar-table').data('month');
    let day = $('.js-zariadenie-choose-day.active').data('day');
    let time = $('.js-choose-time.active').data('time');
    let service_id = $('.js-select-simple-service:checked').data('service-id');
    let service_length = $('.js-select-simple-service:checked').data('service-length');
    let employee_id = $('.js-select-employee.selected').data('employee-id')
    let employee_name = $('.js-select-employee.selected').data('employee-name')

    let data_to_send = {
        action: 'add_simple_calendar_service_to_cart',
        object_id: $('#zariadenie_id').val(),
        service_id: service_id,
        service_length: service_length,
        employee_id: employee_id,
        employee_name: employee_name,
        month: month,
        year: year,
        day: day,
        time: time
    };

    jQuery.post(BASE_URL+'/wp-admin/admin-ajax.php', data_to_send, function(response) {

        response = JSON.parse( response );

        if(response.success){
            notif('success', $('#service_added_to_cart_text').val());
            refresh_header(response.header);
        }else{
            notif(response.notif_type, response.notif);
        }
        $('.js-zariadenie-choose-day.active').click();
    })

    $('.js-choose-time.active').removeClass('active');
    modal_close();
    return false;
});
